module.exports = __webpack_public_path__ + "img/default_pic.0b510d84.png";